import React from 'react';
import { Container, Row, Col } from 'reactstrap';


const SkeletonTechIndustry = () => {
    return (
        <section className="Tech-Industry-Quality tech-quality-skeleton">
            <Container>
                <Row>
                    <Col lg="7">
                        <div className="skeleton-heading"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default SkeletonTechIndustry;
